import { defaultClientRoleId } from "@smart/bridge-smokeball-basic";

import { FieldItem } from "../types";

const personNameFieldNames = new Set(["person/firstName", "person/lastName"]);

const responseValueToText = (raw: unknown): string => {
  if (typeof raw === "string") return raw;
  if (Array.isArray(raw)) return raw[0];
  return "";
};

const getClientLayoutIds = (
  formMatterTypes?: { representativeOptions?: string[] }[],
): Set<string> => {
  const ids = new Set<string>([defaultClientRoleId]);
  if (!formMatterTypes?.length) return ids;
  const lists = formMatterTypes
    .map((mt) => mt.representativeOptions)
    .filter((o): o is string[] => !!o?.length);
  if (!lists.length) return ids;
  const [first, ...rest] = lists;
  for (const role of first) {
    if (rest.every((list) => list.includes(role))) ids.add(role);
  }
  return ids;
};

export const getClientNamesFromResponses = (
  fields: FieldItem[],
  responses: Record<string, unknown>,
  formMatterTypes?: { representativeOptions?: string[] }[],
): { firstName: string; lastName: string } => {
  const layoutIds = getClientLayoutIds(formMatterTypes);
  let firstName = "";
  let lastName = "";
  for (const field of fields) {
    const layoutId = field.layout?.id;
    const fieldName = field.field?.name;
    if (
      layoutId &&
      fieldName &&
      layoutIds.has(layoutId) &&
      personNameFieldNames.has(fieldName)
    ) {
      const text = responseValueToText(responses[field.uri]);
      if (fieldName === "person/firstName" && !firstName) firstName = text;
      if (fieldName === "person/lastName" && !lastName) lastName = text;
    }
  }
  return { firstName, lastName };
};
